export default __webpack_public_path__ + "static/media/logo-approve-me.74b76914.png";